import { ICostInfoDTO } from "../../../libs/coreapi-dto/@types/common"
import { IInvoiceItem, IPricingInvoiceDTO, IPricingInvoiceItem } from "../../../libs/coreapi-dto/dirs/pricingInvoice"

export type eventPricingInvoiceTypes =
    'None' //
    | 'QuantityСhanged' //КВ
    | 'ManufacturerPriceChanged' //ЦИ
    | 'RegisteredPriceChanged' //ЦРеестр
    | 'SupplierMarkupPercentageChanged' //ПРНацОпт
    | 'SupplierVatRatePercentageChanged' //СтНДСОпт
    | 'PercentageOfMarkupRetailChanged' //ПРНац
    | 'PercentageOfVatRateRetailChanged' //СтНДСРозн
    | 'SupplierPriceExcludingVatChanged' //ЦПбезНДС
    | 'SupplierVatPerUnitChanged' //НДСОптЕд
    | 'SupplierPriceWithVatChanged' //ЦПсНДС
    | 'SupplierAmountExcludingVatChanged' //СПбезНДС
    | 'SupplierVatAmountChanged' //НДСОпт
    | 'SupplierAmountWithVatChanged' //СПсНДС
    | 'RetailUnitMarginChanged' //НацЕдРозн
    | 'RetailPriceChanged' //ЦР
    | 'RetailPriceWithVatChanged' //ЦРсНДС
    | 'VatAmountRetailChanged' //НДСРозн
    | 'RetailAmountChanged' //СР
    | 'RetailAmountWithVatChanged' //СРсНДС
    | 'LimitMarginPercentageChanged' //ПРНацМакс
    | 'MaximumSellingPriceChanged' //ЦРсНДСМакс
    | 'ActualMarkupPercentageChanged' //ФактПрНац
    | 'DenominatorChanged' //З

export const collectPricingInvoiceDTO = (
    eventTypes: eventPricingInvoiceTypes,
    idInvoice: string | undefined,
    idSupplier: string | undefined,
    idStore: string | undefined,
    items: IInvoiceItem[]
) => {
    const defaultGuid = '00000000-0000-0000-0000-000000000000'
    return {
        eventType: eventTypes,
        hasAdprice: false,
        hasRetailPrice: true, // по умолчанию сохраняем розн. цену с НДС
        invoice: {
            idGlobal: idInvoice ?? defaultGuid,
            idSupplierGlobal: idSupplier ?? defaultGuid,
            idStoreGlobal: idStore ?? defaultGuid,
            items: items
        }
    } as IPricingInvoiceDTO
}

export const collectPricingInvoiceItem = (
    idItem: string | undefined,
    idGoods: string,
    idScalingRatio: string | undefined,
    quantity: number | undefined,
    producerPrice: number | undefined,
    retailCostInfo: ICostInfoDTO,
    supplierCostInfo: ICostInfoDTO,
    registerPrice: number | undefined,
    numerator?: number,
    denominator?: number,
    important?: boolean
) => {
    const defaultGuid = '00000000-0000-0000-0000-000000000000'
    return {
        idGlobal: idItem ?? defaultGuid,
        idGoodsGlobal: idGoods,
        idScalingRatioGlobal: idScalingRatio ?? defaultGuid,
        quantity: quantity ?? 0,
        producerPrice: producerPrice ?? 0,
        supplierCostInfo: {
            vat: supplierCostInfo.vat ?? 0,
            sum: supplierCostInfo.sum ?? 0,
            sumIncVat: supplierCostInfo.sumIncVat ?? 0,
            vatSum: supplierCostInfo.vatSum ?? 0,
            priceIncVat: supplierCostInfo.priceIncVat ?? 0,
            price: supplierCostInfo.price ?? 0,
            vatPrice: supplierCostInfo.price,
            adprice: supplierCostInfo.adprice
        },
        retailCostInfo: {
            vat: retailCostInfo.vat ?? 0,
            sum: retailCostInfo.sum ?? 0,
            sumIncVat: retailCostInfo.sumIncVat ?? 0,
            vatSum: retailCostInfo.vatSum ?? 0,
            priceIncVat: retailCostInfo.priceIncVat ?? 0,
            price: retailCostInfo.price ?? 0,
            vatPrice: retailCostInfo.vatPrice,
            adprice: retailCostInfo.adprice
        },
        registerPrice: registerPrice ?? 0,
        numerator: numerator,
        denominator: denominator,
        important: important
    } as IPricingInvoiceItem
}
